import * as React from 'react'
import { useState } from 'react'
import { Grid, InputAdornment, TextField } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { useTranslation } from 'react-i18next'
import { SearchLabels } from '../../../../components/SearchLabels'

type Props = {
  onAction: (value: any, chosenLabels: string[]) => void
  labels: string[]
}

export const DataGridHeader = ({ onAction, labels }: Props) => {
  const { t } = useTranslation()
  const [search, setSearch] = useState('')
  const [chosenLabels, setChosenLabels] = useState<string[]>([])
  return (
    <Grid container p={2} direction={{ xs: 'column', sm: 'row' }} alignItems="stretch" justifyContent="flex-start" spacing={2}>
      <Grid item xs={7}>
        <TextField
          fullWidth
          placeholder={`${t('search.title')}`}
          onChange={(value: any) => {
            setSearch(value.target.value)
            onAction(value.target.value, chosenLabels)
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            )
          }}
        />
      </Grid>
      <Grid item xs={5}>
        <SearchLabels
          labels={labels}
          onChange={(selectValues: string[]) => {
            setChosenLabels(selectValues)
            onAction(search, selectValues)
          }}
        />
      </Grid>
    </Grid>
  )
}
